import { useQuery } from '@apollo/client'
import { Spinner } from '@triptcip/common'
import React from 'react'
// import NewHomeVisualBackground from './NewHomeVisualBackground'
import { buildURL } from 'react-imgix'
import styled, { keyframes } from 'styled-components'

import publicTokenCategories from '../../apollo/queries/publicTokenCategories'
import { CONTAINER_WIDTH } from '../../theme'
import { MEDIA_QUERY_DESKTOP } from '../../utils/media-query'
import NewHomeCollectionsMini from './NewHomeCollectionsMini/NewHomeCollectionsMini'
import GuiHeader from './NewHomeHighlighted/GuiHeader'
import NewHomeHighlighted from './NewHomeHighlighted/NewHomeHighlighted'

const float = keyframes`
  0% {
    transform: translatey(0px);
  }
  50% {
    transform: translatey(-20px);
  }
  100% {
    transform: translatey(0px);
  }
`

const Image = styled.img`
  transform: translatey(0px);
  animation: ${float} 6s ease-in-out infinite;
  object-fit: cover;
  object-position: 50% 50%;

  @media (max-width: ${CONTAINER_WIDTH}px) {
    width: 100% !important;
    height: 100% !important;
  }
`

const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8rem 0;
`

const Description = styled.div`
  margin-bottom: 2rem;

  ${MEDIA_QUERY_DESKTOP} {
    white-space: nowrap;
  }
`

const optimizedVoidUri = buildURL('https://triptcip.imgix.net/web-assets/void.jpg', {
  quality: 50,
  width: 1200
})

const NewHome = () => {
  const publicTokenCategoriesQueryRes = useQuery(publicTokenCategories)
  const isLoading = publicTokenCategoriesQueryRes.loading
  const categories = publicTokenCategoriesQueryRes.data?.publicTokenCategories

  return (
    <>
      <GuiHeader />
      <div id='collection'>
        {isLoading ? (
          <Loader>
            <Spinner variant={Spinner.VARIANT_PRIMARY} />
          </Loader>
        ) : (
          <>
            <NewHomeHighlighted tokenMetadata={categories?.[0]?.tokens?.[0]} id='highlight-0' />
            <NewHomeHighlighted tokenMetadata={categories?.[0]?.tokens?.[1]} />
            <NewHomeHighlighted tokenMetadata={categories?.[0]?.tokens?.[2]} />
            <NewHomeHighlighted tokenMetadata={categories?.[0]?.tokens?.[3]} />
            <NewHomeCollectionsMini categories={categories.slice(1, categories.length)} />
          </>
        )}
      </div>
    </>
  )
}

export default NewHome
